// Magic-link sign-in. Shown by App.jsx whenever there's no active Supabase
// Auth session. No password field -- signInWithOtp emails a one-time link;
// clicking it on this device signs the user in and useAuth's
// onAuthStateChange listener picks up the resulting session automatically.
import { useState } from "react";
import { COLORS, FONT_SIZE, SPACE, RADIUS } from "../lib/constants";

export function LoginScreen({ onSignIn }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [errorMessage, setErrorMessage] = useState("");
  const { paper, card, ink, soft, accent, danger, line } = COLORS;

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim() || status === "sending") return;
    setStatus("sending");
    const { error } = await onSignIn(email.trim());
    // Surface the actual reason when there is one (e.g. the invite-only beta
    // gate's rejection message) rather than a generic "try again" -- that
    // would be actively misleading for a deliberate rejection, since trying
    // again can never work.
    setErrorMessage(error?.message || "");
    setStatus(error ? "error" : "sent");
  }

  return (
    <div
      style={{
        background: paper,
        color: ink,
        fontFamily: "var(--font-serif)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: SPACE.x4,
        boxSizing: "border-box",
      }}
    >
      <div style={{ background: card, border: `2px solid ${line}`, borderRadius: RADIUS.xxl, padding: SPACE.x5, maxWidth: 380, width: "100%" }}>
        <h1 style={{ fontSize: FONT_SIZE.h2, fontWeight: 700, margin: "0 0 var(--space-xl)" }}>The weekly kitchen</h1>

        {status === "sent" ? (
          <p className="mp-sans" style={{ color: soft, fontSize: FONT_SIZE.md, margin: 0 }}>
            Check your email for a sign-in link — open it on this device to continue.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="mp-sans" style={{ color: soft, fontSize: FONT_SIZE.md, marginTop: 0 }}>
              Sign in with your email — we'll send a link, no password needed.
            </p>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="mp-sans"
              style={{
                width: "100%",
                padding: "var(--space-lg) var(--space-xl)",
                fontSize: FONT_SIZE.md,
                borderRadius: RADIUS.lg,
                border: `2px solid ${line}`,
                boxSizing: "border-box",
                marginBottom: SPACE.xl,
                fontFamily: "var(--font-sans)",
              }}
            />
            <button
              type="submit"
              disabled={status === "sending"}
              className="mp-sans"
              style={{
                width: "100%",
                padding: "var(--space-lg) var(--space-xl)",
                fontSize: FONT_SIZE.md,
                fontWeight: 600,
                borderRadius: RADIUS.lg,
                border: "none",
                background: accent,
                color: COLORS.onAccent,
                cursor: status === "sending" ? "default" : "pointer",
                opacity: status === "sending" ? 0.7 : 1,
              }}
            >
              {status === "sending" ? "Sending…" : "Send magic link"}
            </button>
            {status === "error" && (
              <p className="mp-sans" style={{ color: danger, fontSize: FONT_SIZE.base, marginBottom: 0, marginTop: SPACE.lg }}>
                {errorMessage || "Something went wrong sending that link — try again."}
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
